import styled from "styled-components";
import {styledByDevice} from "../../../../../themes/architecture/styled-by-device";
import {ACTIVE} from "../../../../../themes/css-global-classes";
import {FilterLinkIconDefaultPCBox, FilterLinkIconDefaultMobileBox} from "./filter-link-icon.default.box";

const MobileSIBox = styled(FilterLinkIconDefaultMobileBox)`
    .${ACTIVE} &{
        background: transparent linear-gradient(180deg, ${props => props.theme.colors.brandSecondaryDark} 0%, #731A11 100%) 0% 0% no-repeat padding-box;  
    }
`;

export const FilterLinkIconSIBox = styledByDevice(FilterLinkIconDefaultPCBox, MobileSIBox);